module.exports = __webpack_public_path__ + "img/GB.0e3d1935.svg";